<template lang="pug">
.content

    //- TOP NAV
    ed-title-nav(ref='header' :title='$t("Business Units and Cost Centers")')
        span(slot='action')
            router-link(v-if='$routerHistory.hasHistory() && $route.query["back-to"]' :to='{ path: $routerHistory.previous().path, hash: "" }')
                i.fa.fa-long-arrow-left
                span &nbsp; {{ $t('Back') + ' ' + $t('to') + ' ' + $t($route.query['back-to']) }}

    //- PAGE
    .container-fluid
      ed-section.active.clear
        .col-md-12.no-pad
          ed-checkbox.text-left(
                  :options=`[{
                    label: "Use Business Units",
                    status: settingsCopy.HasBusinessUnit
                  }]`
                  v-model='settingsCopy.HasBusinessUnit'
                  @click='changeBUSetting'
          )
          ed-checkbox.text-left(
                  :options=`[{
                    label: "Use Cost Centers",
                    status: settingsCopy.HasCostCenter
                  }]`
                  v-model='settingsCopy.HasCostCenter'
                  @click='changeCCSetting'
                  )
          ed-checkbox.text-left(
                  :options=`[{
                    label: "Use paired Business Units and Cost Centers",
                    status: settingsCopy.UseBusinessUnitAndCostCenterMapping
                  }]`
                  v-model='settingsCopy.UseBusinessUnitAndCostCenterMapping'
                  :disabled='disablePairedBUCC'
                  @click='changePairedBUAndCCStatus'
                  )
          div(v-if='displayBUGrid')
              br
              h4 Business Units
              BUList
              br
          div(v-if='displayCCGrid')
              br
              h4 Cost Centers
              CCList
              br
          div(v-if='settingsCopy.UseBusinessUnitAndCostCenterMapping')
              br
              h4 Paired Business Units and Cost Centers
              BUAndCCList
</template>

<script>

import Grid from '@/components/Grid'
import BUList from '../BU-list'
import CCList from '../CC-list'
import BUAndCCList from '../BU-CC-list'
import settings from '@/components/_modules/Admin/settings'

export default {
  components: {
    Grid,
    BUList,
    CCList,
    BUAndCCList
  },

  data() {
    return {
      title: '',
      subtitle: '',
      settings: {},
      settingsCopy: {}
    }
  },

  computed: {
    disablePairedBUCC() {
      return !this.settingsCopy.HasBusinessUnit || !this.settingsCopy.HasCostCenter
    },
    displayBUGrid() {
      return !this.settingsCopy.UseBusinessUnitAndCostCenterMapping && this.settingsCopy.HasBusinessUnit
    },
    displayCCGrid() {
      return !this.settingsCopy.UseBusinessUnitAndCostCenterMapping && this.settingsCopy.HasCostCenter
    }
  },

  created() {
    this.settings = this.$user.$.settings // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings)
  },

  methods: {
    updateSettings(values) {
      const companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'))
      const updatedCompanySettings = {
        ...companySettingsCopy,
        CompanySettings: values
      }
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings))
      this.$user.$.settings = values
      return settings.methods.updateSettings.call(this, values)
    },
    changeBUSetting(e) {
      if (!e.status) {
        this.$nextTick(() => {
          this.settingsCopy.HasBusinessUnit = true
          const message = 'Are you sure you want to turn off Business Units ?'
          this.showWarningMessage('HasBusinessUnit', message)
        })
      } else {
        this.saveSettings()
      }
    },

    changeCCSetting(e) {
      if (!e.status) {
        this.$nextTick(() => {
          this.settingsCopy.HasCostCenter = true
          const message = 'Are you sure you want to turn off Cost Centers ?'
          this.showWarningMessage('HasCostCenter', message)
        })
      } else {
        this.saveSettings()
      }
    },

    changePairedBUAndCCStatus(e) {
      if (!e.status) {
        this.$nextTick(() => {
          this.settingsCopy.UseBusinessUnitAndCostCenterMapping = true
          const message = 'Are you sure you want to manage your BUs & CCs separately ? The pairs of data from your single table will now show in two separate tables if you select this change.'
          this.showWarningMessage('UseBusinessUnitAndCostCenterMapping', message)
        })
      } else {
        this.saveSettings()
      }
    },

    saveSettings(setting) {
      var payload = {
        useBU: this.settingsCopy.HasBusinessUnit,
        useCC: this.settingsCopy.HasCostCenter,
        useBUAndCC: this.settingsCopy.UseBusinessUnitAndCostCenterMapping
      }
      this.api.forms.post(this.api.$.BUAndCC.saveSettings, payload)
        .then(r => {
          this.updateSettings(this.settingsCopy)
        }).catch(e => {
          this.settingsCopy = utils.copy(this.settings)
        })
    },

    showWarningMessage(setting, message) {
      const self = this
      this.$nextTick(() => {
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: { from: 'top', align: 'center' },
          timeout: 0,
          message: message,
          dismiss: 'Yes',
          discard: 'No',
          goto: null,
          onClose: function (dismiss) {
            if (dismiss) {
              self.settingsCopy[setting] = self.settingsCopy[setting] ? false : self.settingsCopy[setting]
              if (!self.settingsCopy.HasCostCenter || !self.settingsCopy.HasBusinessUnit) {
                self.settingsCopy.UseBusinessUnitAndCostCenterMapping = false
              }
              self.saveSettings(setting)
            }
          }
        })
      })
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_modules/BusinessUnitsAndCostCenters/BU-and-CC-settings/index.vue